import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=378e2378&scoped=true&"
import script from "./CustomerLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLayout.vue?vue&type=style&index=0&id=378e2378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378e2378",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage})
